goog.provide("shadow.js.shim.module$$mui$icons_material$Error");
goog.provide("module$shadow_js_shim_module$$mui$icons_material$Error");
shadow.js.shim.module$$mui$icons_material$Error = shadow.js.nativeProvides["@mui/icons-material/Error"] = shadow$bridge("@mui/icons-material/Error");
module$shadow_js_shim_module$$mui$icons_material$Error.default = shadow.js.shim.module$$mui$icons_material$Error;
